export const GRID_CLASS_INTERNAL = "loads-grid loads-grid-fill-height";
export const GRID_CLASS_EXTERNAL = "loads-grid loads-grid-fill-height";
